import React, { FC, memo } from 'react';

import dayjs from 'dayjs';

import i18n from '@/content';
import { tryCopyToClipboard } from '@/components/utils';
import SimpleCell from '../SimpleCell';
import styles from './TimeStampCell.module.scss';

const nameSpace = 'auditLogs.tableColumns';

const formatDate = (date: string): string => {
    const dateObj = new Date(date);
    return dayjs(dateObj).format('YYYY-MM-DD HH:mm:ss');
};

interface TimeStampCellProps {
    timestamp: string;
}

const TimeStampCell: FC<TimeStampCellProps> = ({ timestamp }) => (
    <SimpleCell
        className={styles['timestamp-cell']}
        text={formatDate(timestamp)}
        onClick={() => tryCopyToClipboard(timestamp, i18n.t(`${nameSpace}.timestamp`))}
    />
);

export default memo(TimeStampCell);
